import ProjectInfoModal from '../ProjectInfoModal/ProjectInfoModal';
import ProjectTemplateModal from '../ProjectTemplateModal/ProjectTemplateModal';
import useCreateProject from './hooks/useCreateProject';

const ProjectCreateModal = () => {
  const { step, useFormReturn, isLoading, onPrevClick, onTemplateClick, onValid } = useCreateProject();

  if (step === 1) return <ProjectTemplateModal onTemplateClick={onTemplateClick} />;
  if (step === 2)
    return (
      <ProjectInfoModal
        isLoading={isLoading}
        useFormReturn={useFormReturn}
        onPrevClick={onPrevClick}
        onSubmit={useFormReturn.handleSubmit(onValid)}
      />
    );

  return null;
};

export default ProjectCreateModal;
